"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var Message = exports.default = /*#__PURE__*/(0, _createClass2.default)(function Message() {
  (0, _classCallCheck2.default)(this, Message);
  this.id = null;
  this.body = null;
  this.itemId = null;
  this.userId = null;
  this.userItemId = null;
  this.from = null;
  this.to = null;
  this.date = null;
  this.updatedAt = null;
  this.isMine = null;
  this.location = null;
  this.image = null;
  this.voice = null;
  this.info = null;
  this.sms = null;
  this.call = null;
  this.escrowInterest = null;
  this.actionable = null;
  this.suggestions = null;
  this.replyTo = null;
  this.hasReplied = null;
  this.type = null;
  this.system = null;
  this.displayed = null;
  this.received = null;
  this.showSuggestions = null;
  this.autoReply = null;
  this.systemMessageData = null;
  this.tipTo = null;
  this.leadInfo = null;
  this.categoryId = null;
  this.dealerType = null;
  this.sellerId = null;
  this.buyerId = null;
  Object.seal(this);
});